import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 2.5rem 1rem;
  padding: 0.5rem 1.5rem;

  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;

  input {
    border: 0;
    flex: 1;
  }
`;
